export default __webpack_public_path__ + "static/5-deploy-site-90e03accafcb660403ab10e18ba6b4eb.png";